import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFocusEffect } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { NavigationContainer } from '@src/screens/Common/containers'
import {
  pastEhrAppointmentsSelector,
  upcomingEhrAppointmentsSelector,
} from '@screens/NutritionistHub/models/nutritionistHub.selectors.ts'
import { TabView } from '@src/components'
import { ScheduleNextCallCard } from '../ScheduleNextCall/ScheduleNextCallCard'
import { VideoCallsList } from './VideoCallsList'

export const AllVideoCalls = () => {
  const styles = useStyleSheet(themedStyles)
  const dispatch = useDispatch()

  const upcomingAppointments = useSelector(upcomingEhrAppointmentsSelector)
  const pastAppointments = useSelector(pastEhrAppointmentsSelector)

  const insets = useSafeAreaInsets()

  const [tabIndex, setTabIndex] = useState(0)

  useEffect(() => {
    dispatch({ type: 'nutritionistHub/fetchPastEhrAppointments' })
    dispatch({ type: 'nutritionistHub/fetchAppointmentRecurrence' })
    dispatch({ type: 'nutritionistHub/fetchNextRecurringAppointmentSlot' })
  }, [dispatch])

  useFocusEffect(
    useCallback(() => {
      dispatch({ type: 'nutritionistHub/fetchUpcomingEhrAppointments' })
    }, [dispatch]),
  )

  return (
    <NavigationContainer title="Video calls" style={{ flexGrow: 1 }}>
      <TabView
        onChangeTabIndex={setTabIndex}
        tabIndex={tabIndex}
        variant="small"
        routes={[
          {
            key: 'upcoming',
            title: 'Upcoming',
            sceneComponent: <VideoCallsList appointments={upcomingAppointments} upcoming />,
          },
          {
            key: 'past',
            title: 'Past',
            sceneComponent: <VideoCallsList appointments={pastAppointments} />,
          },
        ]}
      />

      <View style={[styles.scheduleNextCall, { marginBottom: insets.bottom + 16 }]}>
        <ScheduleNextCallCard />
      </View>
    </NavigationContainer>
  )
}

const themedStyles = StyleService.create({
  buttons: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 8,
    padding: 16,
  },
  scheduleNextCall: {
    margin: 16,
  },
})
